import { Auth, API } from "aws-amplify";
import awsConfig from "@/aws-exports";

const buildUsers = (users) => {
  return users.map((user) => {
    const email = user.Attributes.filter((attr) => attr.Name === "email")[0];
    const phone = user.Attributes.filter(
      (attr) => attr.Name === "phone_number"
    )[0];

    return {
      username: user.Username,
      email: email ? email.Value : "",
      phone: phone ? phone.Value : "",
      created: user.UserCreateDate,
      status: user.UserStatus,
      active: user.Enabled,
    };
  });
};

const getUsers = async () => {
  const authData = await Auth.currentSession();
  const payload = {
    headers: { Authorization: authData.idToken.jwtToken },
    body: {
      action: "get_users",
      aws_region: awsConfig.aws_cognito_region,
      userPoolID: awsConfig.aws_user_pools_id,
      data: "{}",
    },
  };
  const response = await API.post("api", "/users", payload);

  if (response.body.result !== "success") throw new Error(response.body.data);

  return buildUsers(response.body.data);
};

const transferPog = async (pogID, sourceUser, targetUser) => {
  const authData = await Auth.currentSession();

  const data = {
    pogID,
    sourceUser,
    targetUser,
  };

  const payload = {
    headers: { Authorization: authData.idToken.jwtToken },
    body: {
      action: "transfer_pog",
      aws_region: awsConfig.aws_cognito_region,
      userPoolID: awsConfig.aws_user_pools_id,
      data: JSON.stringify(data),
    },
  };
  const response = await API.post("api", "/users", payload);

  if (response.body.result !== "success") throw new Error(response.body.data);
};

const deleteUser = async (user) => {
  const authData = await Auth.currentSession();
  const payload = {
    headers: { Authorization: authData.idToken.jwtToken },
    body: {
      action: "delete_user",
      aws_region: awsConfig.aws_cognito_region,
      userPoolID: awsConfig.aws_user_pools_id,
      data: `{'user': '${user}'}`,
    },
  };
  const response = await API.post("api", "/users", payload);

  if (response.body.result !== "success") throw new Error(response.body.data);
};

const confirmUser = async (user) => {
  const authData = await Auth.currentSession();
  const payload = {
    headers: { Authorization: authData.idToken.jwtToken },
    body: {
      action: "confirm_user",
      aws_region: awsConfig.aws_cognito_region,
      userPoolID: awsConfig.aws_user_pools_id,
      data: `{'user': '${user}'}`,
    },
  };
  const response = await API.post("api", "/users", payload);

  if (response.body.result !== "success") throw new Error(response.body.data);
};

export { getUsers, deleteUser, confirmUser, transferPog };
